import {ConnectionChunk} from "../chunks/types/ConnectionChunk";
import {connectionBodyChunkToConnection} from "./connectionBodyChunkToConnection";
import {Connection} from "./types/Connection";

export function connectionChunkToConnection(
  connectionChunk: ConnectionChunk
): Connection<any, any, any> | null {
  const {
    captures: {
      1: connectionBodyChunk
    }
  } = connectionChunk;
  return connectionBodyChunkToConnection(connectionBodyChunk);
}
